import { InfluencerPostService } from '../../../services/influencer-post/influencer-post.service';
import * as Sentry from '@sentry/browser';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { CacheService } from '../../../services/cache/cache.service';
var SameInfluencerTopFivePostsComponent = /** @class */ (function () {
    function SameInfluencerTopFivePostsComponent(influencerPostService, userService, cacheService, translate, pdfService) {
        this.influencerPostService = influencerPostService;
        this.userService = userService;
        this.cacheService = cacheService;
        this.translate = translate;
        this.pdfService = pdfService;
        this.onlyForPaidUser = false;
    }
    SameInfluencerTopFivePostsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.cacheService.get("top_posts_" + this.influencerId, this.influencerPostService.getTopPosts(this.influencerId, this.numberOfPosts, this.currentPost.performingScore)).subscribe(function (data) {
            _this.topPosts = data;
            var hasContainCurrentPost = _this.topPosts.filter(function (p) { return p.urlHash === _this.currentPost.urlHash; }).length > 0;
            if (!hasContainCurrentPost) {
                if (_this.topPosts.length > 5) {
                    _this.topPosts = _this.replaceByCurrentPostIntoTopPost(_this.topPosts, _this.currentPost);
                }
                else {
                    _this.topPosts = _this.addCurrentPostIntoTopPost(_this.topPosts, _this.currentPost);
                }
            }
        }, function (error) {
            Sentry.captureException(new Error('An error happen when fetching top posts.'));
        });
    };
    SameInfluencerTopFivePostsComponent.prototype.replaceByCurrentPostIntoTopPost = function (topPosts, currentPost) {
        var newTopPosts = topPosts;
        if (currentPost.postRank > 5) {
            newTopPosts.splice(topPosts.length - 1, 1, this.currentPost);
        }
        else {
            newTopPosts.splice(currentPost.postRank - 1, 1, this.currentPost);
        }
        return newTopPosts;
    };
    SameInfluencerTopFivePostsComponent.prototype.addCurrentPostIntoTopPost = function (topPosts, currentPost) {
        var newTopPosts = topPosts;
        if (currentPost.postRank > topPosts.length) {
            newTopPosts.push(this.currentPost);
        }
        else {
            newTopPosts.splice(currentPost.postRank - 1, 0, this.currentPost);
        }
        return newTopPosts;
    };
    SameInfluencerTopFivePostsComponent.prototype.goToPost = function (postUrl) {
        if (postUrl) {
            window.open(postUrl, '_blank');
        }
    };
    SameInfluencerTopFivePostsComponent.prototype.getTitle = function (fullTitle) {
        if (!fullTitle) {
            return '';
        }
        return fullTitle.slice(0, 50) + '...';
    };
    SameInfluencerTopFivePostsComponent.prototype.getPlatformIcon = function (id) {
        return this.influencerPostService.getPlatformIconById(id);
    };
    SameInfluencerTopFivePostsComponent.prototype.ngAfterViewInit = function () {
        this.pdfService.incrementNumberReportReady(SameInfluencerTopFivePostsComponent.COMPONENT_NAME);
    };
    SameInfluencerTopFivePostsComponent.prototype.isCurrentPost = function (post) {
        return this.currentPost.urlHash === post.urlHash;
    };
    Object.defineProperty(SameInfluencerTopFivePostsComponent.prototype, "showFallbackView", {
        get: function () {
            if (this.onlyForPaidUser && this.userService.isFreeUser()) {
                return true;
            }
            return !this.topPosts || this.topPosts.length === 0;
        },
        enumerable: true,
        configurable: true
    });
    SameInfluencerTopFivePostsComponent.COMPONENT_NAME = 'SameInfluencerTopFivePostsComponent';
    return SameInfluencerTopFivePostsComponent;
}());
export { SameInfluencerTopFivePostsComponent };



// WEBPACK FOOTER //
// ./src/app/main/post-overview/same-influencer-top-five-posts/same-influencer-top-five-posts.component.ts.pre-build-optimizer.js